import { COLORS } from '@/constants/colors';

export type AnnouncementStatus = 'active' | 'completed' | 'cancelled';

export const getStatusColor = (status: AnnouncementStatus): string => {
  switch (status) {
    case 'active':
      return COLORS.SUCCESS;
    case 'completed':
      return COLORS.PRIMARY;
    case 'cancelled':
      return COLORS.ERROR;
    default:
      return COLORS.GRAY_500;
  }
};

export const getStatusText = (status: AnnouncementStatus): string => {
  switch (status) {
    case 'active':
      return 'Aktywne';
    case 'completed':
      return 'Zakończone';
    case 'cancelled':
      return 'Anulowane';
    default:
      return '';
  }
};


